module.exports = {
    avatar: require('./avatar'),
    basejumping: require('./basejumping'),
    bmx: require('./bmx'),
    diving: require('./diving'),
    longboard: require('./longboard'),
    mix: require('./mix'),
    motorsport: require('./motorsport'),
    // roofing: require('./roofing'),
    scooter: require('./scooter'),
    skate: require('./skate'),
    skateboard: require('./skateboard'),
    ski: require('./ski'),
    snowboard: require('./snowboard'),
    surfing: require('./surfing'),
    wakeboard: require('./wakeboard'),
    parashute: require('./parashute'),
    man: require('./man'),
    kayaking: require('./kayak'),
    climbing: require('./climbing'),
    bike: require('./bike'),
    supsurfing: require('./supsurfing'),
    aquabike: require('./aquabike'),
    mountaineering: require('./mountaineering'),
    wingsuit: require('./wingsuit'),
    windsurfing: require('./windsurfing'),
    zorbing: require('./zorbing'),
    kiting: require('./kiting'),
    rafting: require('./rafting'),
    // volleyball: require('./volleyball'),
    none: require('./none'),
}